<template>
    <li class="main-nav__item"
        :class="[{ 'main-nav__item--cta' : menu.cta }, { 'main-nav__item--has-children' : children.length}]">
        <a v-if="menu.cta" class="main-nav__cta btn btn--a"
        :href="menu.url"> {{ menu.title }}</a>
        <a v-else class="main-nav__link" :href="menu.url"
        v-on:click="onClick(menu.title, $event)"
        v-bind:class="{ 'main-nav__link--hover': active }">
            <span class="main-nav__link-text">
                {{ menu.title }}
            </span>
            <Icon name="chevron-down" />
        </a>
    </li>
</template>

<script>
import DesktopMenuItemChild from './DesktopMenuItemChild.vue';
import Icon from './Icon.vue';
import _ from 'lodash';
import { store } from './store.js'

export default {
    name: 'DesktopMenuItem',
    data() {
        return {
            active: false,
            menu: [],
            children: [],
            store
        };
    },
    methods: {
        onClick(title, event) {
            event.preventDefault();

            this.store.activeSubmenu = title;
        },
    },
    props: ['item', 'lastChild','theme'],
    mounted: function() {
        this.menu = this.item;
        var childs = this.item.children;
        this.children = _.sortBy(childs, 'order');
    },
    components: {
        DesktopMenuItemChild,
        Icon
    },
};
</script>